<script>
async function readAllDirEntries(dirEntry) {
  const reader = dirEntry.createReader();
  const allEntries = [];
  let entries = [];
  do {
    entries = await new Promise((resolve, reject) => {
      reader.readEntries(resolve, reject);
    });
    allEntries.push(...entries);
  } while (entries.length);
  return allEntries;
}

async function entryToFile(fileEntry) {
  return new Promise((resolve, reject) => {
    fileEntry.file(resolve, reject);
  });
}

async function readAllFiles(entries) {
  const toProcess = [...entries];
  const fileEntries = [];
  while (toProcess.length) {
    const entry = toProcess.shift();
    if (entry.isFile) {
      fileEntries.push(entry);
    }
    else {
      toProcess.push(...(await readAllDirEntries(entry)));
    }
  }
  return Promise.all(fileEntries.map(entryToFile));
}

export default {
  name: 'DragAndDrop',
  props: {
    enabled: Boolean,
  },
  emits: ['dropFiles'],
  data() {
    return {
      dragHover: false,
    };
  },
  created() {
    // used to debounce dragover
    this.dragTimeout = null;
  },
  methods: {
    onDragOver(ev) {
      if (this.enabled) {
        ev.preventDefault();

        const { types } = ev.dataTransfer;
        if (
          types && Array.isArray(types)
            ? types.includes('Files')
            : 'Files' in types
        ) {
          this.dragHover = true;
          if (this.dragTimeout !== null) {
            window.clearTimeout(this.dragTimeout);
            this.dragTimeout = null;
          }
        }
      }
    },
    onDragLeave() {
      if (this.enabled) {
        this.dragTimeout = window.setTimeout(() => {
          this.dragHover = false;
          this.dragTimeout = null;
        }, 50);
      }
    },
    async onDrop(ev) {
      if (this.enabled) {
        this.dragHover = false;
        if (ev.dataTransfer.items) {
          const entries = [...ev.dataTransfer.items].map((item) => {
            const getAsEntry = item.webkitGetAsEntry || item.getAsEntry;
            return getAsEntry.call(item);
          });
          const files = await readAllFiles(entries);
          this.$emit('dropFiles', files);
        }
        else {
          this.$emit('dropFiles', Array.from(ev.dataTransfer.files));
        }
      }
    },
  },
};
</script>

<template>
  <div
    v-bind="$attrs"
    @dragover.prevent="onDragOver"
    @dragleave="onDragLeave"
    @drop.prevent="onDrop"
  >
    <slot :drag-hover="dragHover" />
  </div>
</template>
